/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiScenarioAlertedPersonCategory {
    CUSTOMER = 'CUSTOMER',
    COUNTERPARTY = 'COUNTERPARTY'
}


export function instanceOfInternalApiScenarioAlertedPersonCategory(value: any): boolean {
    for (const key in InternalApiScenarioAlertedPersonCategory) {
        if (Object.prototype.hasOwnProperty.call(InternalApiScenarioAlertedPersonCategory, key)) {
            if (InternalApiScenarioAlertedPersonCategory[key as keyof typeof InternalApiScenarioAlertedPersonCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiScenarioAlertedPersonCategoryFromJSON(json: any): InternalApiScenarioAlertedPersonCategory {
    return InternalApiScenarioAlertedPersonCategoryFromJSONTyped(json, false);
}

export function InternalApiScenarioAlertedPersonCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioAlertedPersonCategory {
    return json as InternalApiScenarioAlertedPersonCategory;
}

export function InternalApiScenarioAlertedPersonCategoryToJSON(value?: InternalApiScenarioAlertedPersonCategory | null): any {
    return value as any;
}

export function InternalApiScenarioAlertedPersonCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiScenarioAlertedPersonCategory {
    return value as InternalApiScenarioAlertedPersonCategory;
}

